const config_strg_key = "config_one_dice";

export {config_strg_key}